// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import physics_tool from "../../../../engines/libs/physics_tool";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HitRobGameLayer extends BasePopUpLayer {

    @property({ type: cc.Node, displayName:'' })
	nodeHintAd: cc.Node = null;

    @property(cc.Node)
    gameNode: cc.Node = null;

    @property(cc.Node)
    nodeNextHint: cc.Node = null;

    @property(cc.Label)
    labelReviveNum: cc.Label = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    private curLevel = 1;

    static sReviveCount = 1;

    start () {
        HitRobGameLayer.sReviveCount = gameConfig.AD_HIT_ROB_COUNT;
        physics_tool.openPhysics();
        physics_tool.openCollision();
        this.initLayer();

        this.refreshHintState();

        this.refreshReviveCount();

        O1HD.on(MessageEventKind.EventName.REFRESH_HIT_ROB_REVIVE_COUNT, this.refreshReviveCount, this);
    }

    initLayer() {
        this.nodeNextHint.active = false;
        this.startLevel();
    }

    refreshReviveCount() {
        this.labelReviveNum.string = '×' + HitRobGameLayer.sReviveCount;
    }

    startLevel() {
        utilsView.openPopupLayer(
            'Level/level_flyknife' + this.curLevel
            , BUNDLE_SMALL_NAME.fddsMode
            , this.gameNode
            , {
                parent: this
            }
            , null
            , (node)=> {
                node.opacity = 0;
                cc.tween(node)
                .to(0.25, {opacity: 255})
                .start();
            }
        );
    }

    resetStartLevel() {
        this.startLevel();
    }

    async nextLevel(lvNode: cc.Node) {
        
        if (this.curLevel == 6) {
            let addGoodsList = {};
            addGoodsList[50045] = 1;
            await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
            NormalGameManager._instance.onPushGoods(50045,1);
            this.exitLayer();
            NormalGameManager._instance.setGameData({bFinishHitRob: true});
            this._carryData.parent.startStep6();
            O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
            return;
        }
        this.nodeNextHint.active = true;
        this.nodeNextHint.x = cc.winSize.width + this.nodeNextHint.width;
        let endX = -this.nodeNextHint.x;
        cc.tween(this.nodeNextHint)
        .to(0.35, {x: 0})
        .delay(1.5)
        .call(()=> {
            cc.tween(lvNode)
            .to(0.25, {
                opacity: 0
            })

            this.curLevel++;
            this.startLevel();
        })
        .to(0.25, {x: endX})
        .call(()=> {
            this.nodeNextHint.active = false;
            lvNode.destroy();
            this.refreshHintState();
        })
        .start();
    }

    refreshHintState() {
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.hitRobAdList[this.curLevel-1]) {
            this.nodeHintAd.active = false;
        } else {
            this.nodeHintAd.active = true;
        }
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.hitRobAdList[this.curLevel-1]) {
            this.openHint();
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let gameData = NormalGameManager._instance.getGameData();
            gameData.hitRobAdList[this.curLevel-1] = true;
            NormalGameManager._instance.writeGameData();
            this.openHint();
            this.refreshHintState();
        },()=>{
 
        }, null, "打劫匪看广告获得提示");
    }

    openHint() {
        utilsView.openPopupLayer(
            'prefab/HitRobGameHint'
            , BUNDLE_SMALL_NAME.hitRobBundle
            , this.node
            , {
                level: this.curLevel-1
            }
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeLayer();
    }

    closeLayer() {
        this.exitLayer();
        this._carryData.parent.resetStart();
    }

    exitLayer() {
        physics_tool.closePhysics();
        physics_tool.closeCollision();
        this.destroyNode();
    }
    
    // update (dt) {}
}
